import { useEffect, useState } from 'react'
import { Box } from '@chakra-ui/react'
import { TicTacToeContext } from '../context/TicTacToeContext'
import StartGame from './ttt/StartGame'
import GameBoard from './ttt/GameBoard'

export default function TTTForm() {
  const [gameDetails, setGameDetails] = useState({
    playerOne: '',
    playerTwo: '',
    gameId: -1,
    winner: '',
    state: -1,
    gameBoard: [],
    formNumber: 1,
    address: '',
  })

  function nextForm(num: number) {
    setGameDetails({ ...gameDetails, formNumber: num })
  }

  useEffect(() => {
    if (gameDetails.state === -1) {
      nextForm(1)
    } else {
      nextForm(2)
    }
  }, [gameDetails.state])

  return (
    <Box
      borderWidth="1px"
      rounded="lg"
      shadow="1px 1px 3px rgba(0,0,0,0.3)"
      maxW={{ base: 'xl', md: 'lg' }}
      p={{ base: '6' }}
      m="10px"
      as="form"
    >
      <TicTacToeContext.Provider value={{ gameDetails, setGameDetails, nextForm }}>
        {gameDetails.formNumber === 1 && <StartGame />}
        {gameDetails.formNumber === 2 && <GameBoard />}
      </TicTacToeContext.Provider>
    </Box>
  )
}
